

export class Model_CRM_Telecall_Next_Followup {

    public Tele_Call_Id: Number;
    public TeleCall_NextFollowUp_Date: string;
    public TeleCallNext_Time: string
}